import routerOptions0 from "/var/www/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@babel+plugin-syntax-typ_f88ca4ddfd0bfdff048c5d28a6e81f57/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/var/www/apps/front-office/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}